import React, { useState } from "react";

export default function Accordion({ items }) {
    const [openIndex, setOpenIndex] = useState(null);

    const toggle = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className="divide-y divide-gray-200 border rounded-lg">
            {items.map((item, index) => (
                <div key={index}>
                    <button
                        onClick={() => toggle(index)}
                        className="w-full text-left px-4 py-3 flex justify-between items-center focus:outline-none"
                    >
                        <span className="font-medium">{item.title}</span>
                        <span>{openIndex === index ? "−" : "+"}</span>
                    </button>
                    {openIndex === index && (
                        <div className="px-4 pb-4 text-gray-600 text-sm">{item.content}</div>
                    )}
                </div>
            ))}
        </div>
    );
}
